module.exports = __webpack_public_path__ + "static/media/grid-2.4068e674.svg";